import { localStorageUtil } from '../../utils/local-storage.util';

// One entry per table INSTANCE. Before scoping, every paginated table shared a single
// `paginationPage` key: paging one table to page 2 made every other table on the route request
// the same offset, so tables holding a single page of rows rendered empty over data that exists
// (staging 2026-08-20 — Events rows showed "Nothing here!" while their header still counted
// "1 Transaction", because each per-event request went out with take=5&skip=5).
const PAGINATION_KEY_PREFIX = 'paginationPage:';

// Pre-scoping key. Still cleared by clearAll so a browser carrying the old entry does not keep
// it around forever; nothing reads it any more.
const LEGACY_PAGINATION_KEY = 'paginationPage';

const scopedStore = (scope: string) => localStorageUtil<number>(`${PAGINATION_KEY_PREFIX}${scope}`);

export const paginationStorage = {
  // Called on every route change (AppLayout). Clearing the whole family — rather than one key —
  // is also what bounds the entry count: scopes keyed by entity id (per event, per stakeholder)
  // would otherwise accumulate in localStorage indefinitely.
  clearAll: () => {
    // Collect first, then remove: removeItem() reindexes localStorage, so deleting while walking
    // it by index skips entries.
    const staleKeys: string[] = [];
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (key && (key === LEGACY_PAGINATION_KEY || key.startsWith(PAGINATION_KEY_PREFIX))) {
        staleKeys.push(key);
      }
    }
    staleKeys.forEach((key) => localStorage.removeItem(key));
  },
  get: (scope: string) => scopedStore(scope).get(),
  set: (scope: string, page: number) => scopedStore(scope).set(page),
};
